import React, { useState, useRef, useHistory } from "react";
import { useTranslation } from "react-i18next";
import { UncontrolledCollapse } from "reactstrap";
import { FaCog } from "react-icons/fa";

import WebUserStatus from "../../etc/list/WebUserStatus";
import WebConfigMemberList from "./WebConfigMemberList";

const WebConfigSubDomainInfo = ({ idx, userKind, isStandardType, subDomain_info, goToConfigPage, goToConfigMemberPage, goToPassListPage, toggleModalOpened, togglePWModalOpened, toggleSubDomainAdminModalOpened, toggleCreateSubDomainAdminModalOpened }) => {
    const { t } = useTranslation();

    const [isOpened, setIsOpened] = useState(false);

    const enterTimeRef = useRef(0);
    const exitTimeRef = useRef(0);

    const onEnteringEvent = () => {
        enterTimeRef.current = Date.now();
        console.log("onEnteringEvent - ", enterTimeRef.current);
        // setIsOpened(true);
    }

    const onEnteredEvent = () => {
        let enteredTime = Date.now() - enterTimeRef.current;
        console.log("onEnteredEvent - ", enteredTime);
        setIsOpened(true);
    }

    const onExitingEvent = () => {
        exitTimeRef.current = Date.now();
        console.log("onExitingEvent - ", exitTimeRef.current);
        setIsOpened(false);
    }

    const onExitedEvent = () => {
        let exitedTime = Date.now() - exitTimeRef.current;
        console.log("onExitedEvent - ", exitedTime);
        setIsOpened(false);
    }

    const goToMemberConfigPage = () => {

    }

    return (
        <tbody>
            {/* teacher/class 탭과 동일한 list-table 행 스타일 (기존 컬럼 구성·핸들러는 그대로 유지)
                주의: display:flex 클래스는 td가 아니라 td 내부 div에 적용
                (td 자체에 display:flex를 주면 table-cell 박스가 깨져 열 정렬이 무너짐) */}
            <tr>
                <td className="text-center">
                    {/* 260804 서브 도메인 이름이 길 때 줄바꿈되던 문제 수정 - text-area(display:contents)가
                        폭 제약을 못 걸어주던 걸 flex 셀(admin-ellipsis-cell)로 바꾸고 말줄임(...) 처리 추가 */}
                    <div className="d-flex align-items-center justify-content-center admin-ellipsis-cell">
                        <span className="info title hiclass-text admin-ellipsis-text" title={subDomain_info.subDomainName}>{subDomain_info.subDomainName}</span>
                        <FaCog className="font-sm grey-text ml-1 button" style={{ verticalAlign: 'middle', flexShrink: 0 }} onClick={() => goToConfigPage({ subDomain_info: { subDomainSeq: subDomain_info.subDomainSeq, subDomainName: subDomain_info.subDomainName, selectedIdx: idx } })} />
                    </div>
                </td>
                <td className="small text-center">
                    <div className="landscape-to-portrait">
                        <div className="list-row justify-content-center area-60">
                            <WebUserStatus kind={"userStatus"} list_member={subDomain_info.list_member} />
                        </div>
                        <div className="list-row justify-content-center area-40">
                            <button type="button" className="btn-table-action" onClick={() => goToConfigMemberPage({ subDomain_info: { ...subDomain_info, selectedIdx: idx } })}>
                                {t("조회", { ns: "common" })}
                            </button>
                        </div>
                    </div>
                </td>
                <td className="small text-center">
                    <div className="landscape-to-portrait">
                        <div className="list-row area-50">
                            <span className="only-mobile">T :&nbsp;</span>{subDomain_info.chatRoomCnt}
                        </div>
                        <div className="list-row area-50">
                            <span className="only-mobile">L :&nbsp;</span>
                            {
                                subDomain_info.liveOnCnt > 0 ?
                                    <span className="green-text font-weight-bold">{subDomain_info.liveOnCnt}</span> :
                                    <span>{subDomain_info.liveOnCnt}</span>
                            }
                            <span>&nbsp;{" / " + subDomain_info.liveCnt}</span>
                        </div>
                    </div>
                </td>
                <td className="text-center">
                    {
                        isStandardType &&
                        <button type="button" className="btn-table-action" onClick={() => goToPassListPage({ subDomainSeq: subDomain_info.subDomainSeq })}>
                            {t("조회", { ns: "common" })}
                        </button>
                    }
                </td>
            </tr>
            {/* <tr className="d-flex">
                <td className="d-flex w-100 p-0">
                    <UncontrolledCollapse className="w-100" toggler={"#show_" + subDomain_info.subDomainSeq + "_member"} defaultOpen={false} onEntered={onEnteredEvent} onEntering={onEnteringEvent} onExiting={onExitingEvent} onExited={onExitedEvent}>
                        <WebConfigMemberList
                            userKind={userKind}
                            isOpened={isOpened}
                            subDomain_info={subDomain_info}
                            list_member={subDomain_info.list_member}
                            toggleModalOpened={toggleModalOpened}
                            togglePWModalOpened={togglePWModalOpened}
                            toggleSubDomainAdminModalOpened={toggleSubDomainAdminModalOpened}
                            toggleCreateSubDomainAdminModalOpened={toggleCreateSubDomainAdminModalOpened}
                        />
                    </UncontrolledCollapse>
                </td>
            </tr> */}
        </tbody>
    );
}

export default WebConfigSubDomainInfo;